import React, { useCallback, useRef } from 'react';
import MarkdownIt from 'markdown-it';
import styles from './index.module.less';

function MarkdownRender(props) {
  const { text = '' } = props;
  // Markdown 渲染规则
  const mdParser = useRef(
    new MarkdownIt({
      html: true,
      xhtmlOut: true,
    })
  );

  const html = React.useMemo(() => {
    if (text) return mdParser.current.render(text);
    return '';
  }, [text]);

  return <div className={styles.maParse} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default MarkdownRender;
